import * as React from 'react';
export const trialSvg = React.forwardRef(function trialSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 0 1.5H12v3.124a.75.75 0 0 1-.21.52L9.166 7.871l2.625 2.736a.75.75 0 0 1 .209.519V14.5h.75a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1 0-1.5H4v-3.374a.75.75 0 0 1 .209-.52L6.826 7.88 4.208 5.142A.75.75 0 0 1 4 4.624V1.5h-.75A.75.75 0 0 1 2.5.75Zm3 .75h5v2.822L7.992 6.928 5.5 4.323V1.5Zm0 9.928L8 8.822l2.5 2.606v2.822h-5v-2.822Z',
    }),
  );
});
trialSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var trial = {
  category: 'icon',
  colorable: true,
  name: 'trial',
  svg: trialSvg,
};
